import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Process from './components/Process';
import CaseStudies from './components/CaseStudies';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://immobilitalia.com';

  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Service Immobil Sicily",
    "description": "Land consultancy in Sicily offering slope analysis, feasibility studies, due diligence, permitting support and GIS mapping for development projects.",
    "url": siteUrl,
    "logo": "https://public.readdy.ai/ai/img_res/f6f2763d-db5f-4bb2-a284-c0c30ee4ca43.png",
    "email": "info@immobilitalia.com",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Sicily",
      "addressCountry": "IT"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "37.5999938",
      "longitude": "14.0153557"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Sicily"
    },
    "serviceType": [
      "Land Consultancy",
      "Slope Analysis",
      "Feasibility Analysis",
      "Due Diligence",
      "Permitting Support",
      "GIS Mapping"
    ]
  };

  useEffect(() => {
    const navbar = document.querySelector('nav');
    
    const handleScroll = () => {
      if (navbar) {
        if (window.scrollY > 50) {
          navbar.classList.add('bg-white', 'shadow-md');
          navbar.classList.remove('bg-transparent');
        } else {
          navbar.classList.add('bg-transparent');
          navbar.classList.remove('bg-white', 'shadow-md');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <SEOHead
        title="Sicily Land Consultancy | Service Immobil Sicily"
        description="Service Immobil Sicily provides land consultancy services in Sicily including slope analysis, feasibility studies, due diligence, permitting support, and GIS mapping for development projects. Technical analysis and decision support for land development across Sicily."
        keywords="land consultancy Sicily, slope analysis, feasibility studies, due diligence, permitting support, GIS mapping"
        canonical={siteUrl}
        schema={schema}
      />
      <div className="min-h-screen">
        <Navbar />
        <Hero />
        <Services />
        <About />
        <Process />
        <CaseStudies />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
